// Renders the OTP page
// We have this here because the OTP page can be accessed from either
// credit-gateway or my-account-home(-bcom)
// These features trigger an event which the PageApp here is listening to
async function renderOneTimePaymentPage(paramApp, options) {
  const app = paramApp;
  const otpData = options || {};
  const pageAppOTPData = app.oneTimePaymentData || {};
  const OneTimePaymentPage = (await import(/* webpackChunkName: "one-time-payment" */ `@feature/credit-gateway/src/${process.env.ENTRY_POINT}/pages/OneTimePayment/OneTimePaymentPage.js`)).default;

  // if these fields are not set on App.oneTimePaymentData,
  // then do not include these attribtues
  // This will allow the defaults set in the OneTimePaymentModel to take effect
  // These are set so the users selections are preserved
  if (pageAppOTPData.selectedPaymentAmount) {
    otpData.selectedPaymentAmount = pageAppOTPData.selectedPaymentAmount;
  }
  if (pageAppOTPData.selectedPaymentAmountField) {
    otpData.selectedPaymentAmountField = pageAppOTPData.selectedPaymentAmountField;
  }
  if (pageAppOTPData.selectedPaymentDateField) {
    otpData.selectedPaymentDateField = pageAppOTPData.selectedPaymentDateField;
  }
  if (pageAppOTPData.selectedPaymentDate) {
    otpData.selectedPaymentDate = pageAppOTPData.selectedPaymentDate;
  }

  if (!app.oneTimePaymentData) {
    app.oneTimePaymentData = options;
  }

  if (app.oneTimePaymentView) {
    app.oneTimePaymentView.destroy();
  }

  app.oneTimePaymentView = new OneTimePaymentPage(otpData).start();
  app.channel.trigger('otp:load:done');
}

module.exports = (paramApp) => {
  const App = paramApp;
  // This event is triggered in the PageRouter when route matches a OTP route
  // This is hit only when clicking browser back/forward button
  App.channel.on('app:init-feature', ({
    feature,
  }) => {
    if (feature === 'one-time-payment-page') {
      renderOneTimePaymentPage(App, App.oneTimePaymentData);
    }
  });

  // Update oneTimePaymentData object so that when user goes back
  // to different OTP pages, we preserve their selections
  // When user goes back in the browser, the page does not do a full refresh
  // App.oneTimePaymentData is kept, so we update this object as the user fills
  // out the form. When we render OTP, we pass in this data to OTP
  App.channel.on('update:otp:payment:amount', (key, value) => {
    if (App.oneTimePaymentData) {
      App.oneTimePaymentData.selectedPaymentAmountField = key;
      App.oneTimePaymentData.selectedPaymentAmount = value;
    }
  });

  // Same as above but for Date
  App.channel.on('update:otp:payment:date', (key, value) => {
    if (App.oneTimePaymentData) {
      App.oneTimePaymentData.selectedPaymentDateField = key;
      App.oneTimePaymentData.selectedPaymentDate = value;
    }
  });

  // Trigger this event when we render OTP for the first time
  // Do this so the selections from the previous OTP session
  // dont carry over into this new one
  App.channel.on('clear:otp:data', () => {
    App.oneTimePaymentData = undefined;
  });

  App.channel.on('render:one:time:payment:page', renderOneTimePaymentPage);
};
